import Vue from 'vue'
import Vuex from 'vuex'
import Storage from '@/helpers/storage'
import Api from '@/api'
import ENUM from '@/assets/ENUM'

import UCUser from '@/app-core/use-cases/user'
import Auth from '@/modules/auth'
import Router from "@/router";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        
        user: {},
        stats: {},
        settings: {},
        partners: {},
        email: '',
        scroll: false,
        lang: '',
        page: '',
        maintenance: false,
        internet: true,
        fastPass: false,
        newsletters: {subscriptions: []},
        newslettersWaitingUserRefresh: {},
        countSelectedNewsletters: 0,
        unselectedAllNewsletters: false,
        newslettersSort: ENUM.NEWSLETTERS.SORT.NOT_SET,
        newslettersLoaded: false,
        isConnected: false,
        fetching: false,
        mailboxes: [
            {
                email: '',
                provider: '',
                checked: true,
                count: 0,
                done: false,
                isActive: true
            }
        ],
        isCardTuto: false,
        showBottomSheetAddMailbox: false,
        showScanMailboxesEnding: false
    },
    mutations: {
        
        UPDATE_USER: (state, user) => {
            state.user = user
        },
        
        UPDATE_STATS: (state, stats) => {
            
            state.stats = stats
        },
        
        UPDATE_SETTINGS: (state, settings) => {
            state.settings = settings
        },
        
        UPDATE_PARTNERS: (state, partners) => {
            state.partners = partners
        },
        
        EMAIL: (state, email) => {
            state.email = email
        },
        
        SCROLL: (state, bool) => {
            state.scroll = bool
        },
        
        LANG: (state, lang) => {
            state.lang = lang
        },
        
        PAGE: (state, page) => {
            state.page = page
        },
        
        MAINTENANCE: (state, maintenance) => {
            state.maintenance = maintenance
        },
        
        INTERNET: (state, internet) => {
            state.internet = internet
        },
        
        UPDATE_FAST_PASS: (state, fastPass) => {
            state.fastPass = fastPass
        },
        
        NEWSLETTERS: (state, newsletters) => {
            state.newsletters = newsletters
            state.newslettersLoaded = true
        },
        
        NEWSLETTERS_WAITING_USER_REFRESH: (state, newslettersWaitingUserRefresh) => {
            state.newslettersWaitingUserRefresh = newslettersWaitingUserRefresh
        },
        
        COUNT_SELECTED_NEWSLETTERS: (state, countSelectedNewsletters) => {
            state.countSelectedNewsletters = countSelectedNewsletters
        },
        
        UNSELECT_ALL_NEWSLETTERS: (state, unselectedAllNewsletters) => {
            state.unselectedAllNewsletters = unselectedAllNewsletters
        },
        
        NEWSLETTERS_SORT: (state, newslettersSort) => {
            state.newslettersSort = newslettersSort
        },
        
        IS_CONNECTED: (state, isConnected) => {
            state.isConnected = isConnected
        },
        
        FETCHING: (state, fetching) => {
            state.fetching = fetching
        },
        
        MAILBOXES: (state, mailboxes) => {
            state.mailboxes = mailboxes
        },
        
        IS_CARD_TUTO: (state, isCardTuto) => {
            state.isCardTuto = isCardTuto
        },
        
        SHOW_BOTTOM_SHEET_ADD_MAILBOX: (state, showBottomSheetAddMailbox) => {
            state.showBottomSheetAddMailbox = showBottomSheetAddMailbox
        },
    
        SHOW_SCAN_MAILBOXES_ENDING: (state, showScanMailboxesEnding) => {
            state.showScanMailboxesEnding = showScanMailboxesEnding
        }
        
    },
    getters: {
        user: state => state.user,
        stats: state => state.stats,
        settings: state => state.settings,
        partners: state => state.partners,
        scroll: state => state.scroll,
        lang: state => state.lang,
        page: state => state.page,
        maintenance: state => state.maintenance,
        internet: state => state.internet,
        fastPass: state => state.fastPass,
        newsletters: state => state.newsletters,
        newslettersWaitingUserRefresh: state => state.newslettersWaitingUserRefresh,
        countSelectedNewsletters: state => state.countSelectedNewsletters,
        unselectedAllNewsletters: state => state.unselectedAllNewsletters,
        newslettersSort: state => state.newslettersSort,
        newslettersLoaded: state => state.newslettersLoaded,
        isConnected: state => state.isConnected,
        fetching: state => state.fetching,
        mailboxes: state => state.mailboxes,
        isCardTuto: state => state.isCardTuto,
        showBottomSheetAddMailbox: state => state.showBottomSheetAddMailbox,
        showScanMailboxesEnding: state => state.showScanMailboxesEnding,
        anonymousUser: state => state.user && (!state.user.firstname || !state.user.lastname || (!state.user.birthYear || state.user.birthYear < 1))
    },
    actions: {
        
        setUser: (store, user = {}) => store.commit('UPDATE_USER', user),
        
        disconnect(store) {
            
            Storage.removeItem('token')
            store.commit('UPDATE_USER', {})
        },
        
        getUserAsync: function (store) {
    
            if (store.state.user && store.state.user.accounts) {
                return Promise.resolve(store.state.user)
            } else {
                return UCUser.getUserAsync()
                    .then(user => {
                        store.dispatch('setUser', user)
                        store.dispatch('updateIsConnected', true)
                        return user
                    })
            }
        },
        
        getStatsAsync: async function ({commit, state}) {
            
            //refresh always stats, but some modules need stats
            return Api.user.getStats()
                .then(stats => {
                    commit('UPDATE_STATS', stats)
                    return stats
                })
        },
        
        getSettingsAsync: function ({commit, state}) {
            return Api.user.getSettings()
                .then(settings => {
                    commit('UPDATE_SETTINGS', settings)
                    return settings
                })
        },
        
        getPartnersAsync: function ({commit, state}) {
            if (Object.keys(state.partners).length) {
                return state.partners
            }
            return Api.partners.getAll()
                .then(partners => {
                    commit('UPDATE_PARTNERS', partners)
                    return partners
                })
        },
        
        setLang: (store, lang) => store.commit('LANG', lang),
        
        setPage: (store, page) => store.commit('PAGE', page),
        
        setMaintenance: (store, maintenance) => store.commit('MAINTENANCE', maintenance),
        
        setInternetStatus: (store, bool) => store.commit('INTERNET', bool),
        
        updateFastPass: (store, bool) => store.commit('UPDATE_FAST_PASS', bool),
        
        updateNewsletters: (store, newsletters) => store.commit('NEWSLETTERS', newsletters),
        
        updateNewslettersWaitingUserRefresh: (store, newslettersWaitingUserRefresh) => store.commit('NEWSLETTERS_WAITING_USER_REFRESH', newslettersWaitingUserRefresh),
        
        refreshNewsletters: async (store, asyncFetchMeantime) => {
            if(Storage.getItem('token')) {
    
                store.dispatch('updateFetching', true)
                const data = await UCUser.refreshSubscriptions(asyncFetchMeantime)
                store.dispatch('updateFetching', false)
    
                store.dispatch('updateNewsletters', data)
                store.dispatch('updateMailboxes', data.mailboxes)
                return data
            }
        },
        
        refreshUnfinishedMailboxes: async (store) => {
            const data = await  UCUser.waitUnfinishedMailboxes()
            store.dispatch('updateNewslettersWaitingUserRefresh', data)
            store.dispatch('updateShowScanMailboxesEnding', true)
        },
        
        userAcceptNewSubscriptions(store) {
            const newsletters = store.getters.newslettersWaitingUserRefresh
            store.dispatch('updateNewsletters', newsletters)
            store.dispatch('updateMailboxes', newsletters.mailboxes)
            store.dispatch('updateNewslettersWaitingUserRefresh', {})
            store.dispatch('updateShowScanMailboxesEnding', false)
        },
        
        updateSubscriptions: (store, subscriptions) => {
            const newsletters = {...store.getters.newsletters} //clone for break VUEX mutation error
            newsletters.subscriptions = subscriptions
            store.dispatch('updateNewsletters', newsletters)
        },
        
        updateCountSelectedNewsletters: (store, countSelectedNewsletters) => store.commit('COUNT_SELECTED_NEWSLETTERS', countSelectedNewsletters),
        
        unselectedAllNewsletters: (store) => store.commit('UNSELECT_ALL_NEWSLETTERS', !store.getters.unselectedAllNewsletters),
        
        updateNewslettersSort: (store, newslettersSort) => {
            store.commit('NEWSLETTERS_SORT', newslettersSort)
            Storage.setItem('newslettersSort', newslettersSort)
        },
        
        updateIsConnected: (store, isConnected) => store.commit('IS_CONNECTED', isConnected),
        
        updateFetching: (store, fetching) => store.commit('FETCHING', fetching),
        
        updateMailboxes: (store, mailboxes) => {
            store.commit('MAILBOXES', mailboxes)
        },
        
        updateIsCardTuto: (store, isCardTuto) => store.commit('IS_CARD_TUTO', isCardTuto),
        
        updateShowBottomSheetAddMailbox: (store, showBottomSheetAddMailbox) => store.commit('SHOW_BOTTOM_SHEET_ADD_MAILBOX', showBottomSheetAddMailbox),
        
        removeMailboxes: (store, removedEmail) => {
            const currentMailboxes = JSON.parse(JSON.stringify(store.state.mailboxes))
            const newMailboxes = currentMailboxes.filter(mailbox => mailbox.email !== removedEmail)
            store.dispatch('updateMailboxes', newMailboxes)
        },
        
        initNewsletterSort: (store, removedEmail) => {
            const newslettersSort = Storage.getItem('newslettersSort')
            if (newslettersSort && Object.values(ENUM.NEWSLETTERS.SORT).includes(newslettersSort)) {
                store.dispatch('updateNewslettersSort', newslettersSort)
            } else {
                store.dispatch('updateNewslettersSort', ENUM.NEWSLETTERS.SORT.NOT_SET)
            }
        },
        
        updateShowScanMailboxesEnding: (store, value) => {
            store.commit('SHOW_SCAN_MAILBOXES_ENDING', value)
        }
        
    },
    strict: true
})
